$(document).ready(function() {
  $("body").find("button.w-full.button-primary--outline").addClass("product-form__submit");
  setInterval(function () {
   var itemsPerPage = 1;
  $(".needsclick.kl-private-reset-css-Xuajs1").each(function(){           
  $(this).addClass("klaviyo_section"+ itemsPerPage);
  itemsPerPage++;    
    });
     $(".newsletter_block .klaviyo-form-Tda5jx").show();
    }, 9000);
});




function checkIfReviewsElementIsReady() 
{
  if ($(window).width() < 1024)
  {
    const titleDiv = $('main section.grid .items-baseline > div[data-product-block="title"]');
    let title = titleDiv.get(0).outerHTML;
    titleDiv.remove();
    $('.shopify-section article.w-full').before(title);
    let found = false;
    let attempts = 0;
    const maxAttempts = 50;
    const intervalTime = 500;
    let interval = setInterval(() => 
    {
      if (!found) 
      {
        const element = document.querySelectorAll('section [data-product-block="@app"].col-span-12 .yotpo-star-rating-reviews-summary-link');
        if (element.length > 0) 
        {
          clearInterval(interval);
          found = true;
          moveTitleAndReview();
        }
      }
      if (attempts >= maxAttempts) 
      {
          clearInterval(interval);
      }
        attempts++;
    }, intervalTime);

    function moveTitleAndReview() 
    {
      const reviewsDiv = $('section [data-product-block="@app"].col-span-12'); 
      let reviewsHtml = reviewsDiv.get(0).outerHTML;
      reviewsDiv.hide();
      setTimeout( function()
      {
        $('.shopify-section article.w-full').before('<div id="view-review-list">'+reviewsHtml+'</div>');

        $('#view-review-list .yotpo-star-rating-reviews-summary-text').on('click', function(event) 
        {
          event.preventDefault();
          $('.items-baseline .yotpo-star-rating-reviews-summary-text').click();
        });
      }, 500);
    }
  }
}
checkIfReviewsElementIsReady();